// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_b0-2";
export var aiChatCartContainerExit = "_b0-4";
export var aiChatContainerLarge = "_b0-0";
export var aiChatContainerSmall = "_b0-1";
export var aiChatIcon = "_b0-6";
export var slideInFromRight = "_b0-3";
export var slideOutToRight = "_b0-5";